"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_ENVIRONMENT = exports.NORMALIZE_DEPTH = exports.SENTRY_DSN = void 0;
exports.SENTRY_DSN = process.env.SENTRY_DSN ||
    process.env.SENTRY_PUBLIC_DSN ||
    process.env.NODE_SENTRY_PUBLIC_DSN ||
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    process.env.REACT_APP_SENTRY_PUBLIC_DSN;
exports.NORMALIZE_DEPTH = Number(process.env.SENTRY_NORMALIZE_DEPTH || process.env.NEXT_PUBLIC_SENTRY_NORMALIZE_DEPTH || 10);
exports.SENTRY_ENVIRONMENT = process.env.SENTRY_ENVIRONMENT || process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
